import React, { Component } from 'react'
import PropTypes from 'prop-types'

export const styles = {
  FONT_FAMILY_ARIAL: {
    fontFamily: 'Arial, Helvetica, sans-serif'
  },
  FONT_FAMILY_TIMES: {
    fontFamily: '"Times New Roman", Times, serif'
  },
  FONT_FAMILY_LUCIDA: {
    fontFamily: '"Lucida Console", Monaco, monospace'
  },
  FONT_FAMILY_GEORGIA: {
    fontFamily: 'Georgia, serif'
  }
}

export default class FontFamily extends Component {
  static propTypes = {
    toggleStyleGroup: PropTypes.func.isRequired,
    editorState: PropTypes.object.isRequired
  }

  handleChange = event => {
    event.preventDefault()
    this.props.toggleStyleGroup(styles, event.target.value)
  }

  render() {
    const currentStyle = this.props.editorState.getCurrentInlineStyle()
    const selected = Object.keys(styles).find(style => currentStyle.has(style)) || ''
    return (
      <select onChange={this.handleChange} value={selected}>
        <option value="">Default</option>
        {Object.keys(styles).map(style => (
          <option key={style} value={style}>
            {styles[style].fontFamily.replace(/"/g, '')}
          </option>
        ))}
      </select>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/RichText/controls/font_family.js